import React, { useState } from 'react';
import styles from './Letter.module.scss';
import letterIcon from '../assets/letter.gif';

function Letter() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        {isOpen ? (
          <div className={styles.openedLetterContainer}>
            안녕 서현아!
            <br />
            먼저 네가 태어난 이 날을 함께 기억하고 축하해줄 수 있게 해줘서 너무 고마워. 생일 축하해.
            <br />
            너와 함께 보낸 시간이 얼마나 소중한지, 그리고 너와의 삶이 얼마나 의미 있는지 말로는 다 표현하기 어렵지만 이
            편지를 통해 조금이나마 내 마음을 전하고 싶어.
            <br />
            너와 함께하는 모든 순간은 내게 너무 특별하면서도 감사해.
            <br />
            너의 웃음소리, 너의 따뜻한 마음, 그리고 너 자체가 내게는 큰 축복이야.
            <br />
            이 특별한 날을 기념하며, 네 바람과 꿈들이 모두 이루어지기를 기도할게.
            <br />
            너와 함께 아름다운 추억을 쌓아나가며 항상 응원할 거야.
            <br />
            너의 하루하루가 기쁨과 웃음으로 가득하고, 더 행복한 날들을 함께 보내는 예쁜 우리들로 계속될 수 있기를 바래.
            <br />
            언제나 따뜻한 품안에서 서로를 신뢰하며 큰 웃음과 사랑으로 가득한 미래를 그려나가보자.
            <br />
            <br />
            <br />
            <div className={styles.letterLast}>2023. 03. 22</div>
            <div className={styles.letterLast}>너의 생일을 축하하며, 현우가</div>
          </div>
        ) : (
          <div className={styles.unOpenedetterContainer} onClick={() => setIsOpen(true)}>
            <img className={styles.unOpenedLetter} src={letterIcon} alt='letterIcon' />
            <div className={styles.clickMe}>날 눌러줘!</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Letter;
